import React from "react";
import { Box, Typography, Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { ReactComponent as NutritionTargetsEmptyIcon } from "../../icons/NutritionTargetsEmpty.svg";
import { colorSystem } from "../../theme";
import { useClient } from "../../hooks/useClient";

const useStyles = makeStyles((theme) => ({
  emptyContainer: {
    width: "100%",
    textAlign: "center",
    backgroundColor: colorSystem.gray10,
    borderRadius: 4,
    borderColor: colorSystem.gray7,
    borderWidth: 1,
    borderStyle: "solid",
    padding: theme.spacing(3, 0),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },

  emptyText: {
    color: colorSystem.gray,
    paddingTop: theme.spacing(1),
  },

  button: {
    fontWeight: 700,
    borderWidth: 2,
    borderColor: colorSystem.black,
    width: 170,
    height: 56,
    marginTop: theme.spacing(3),
  },
}));

export interface ClientNutritionTargetEmptyProps {
  type: "entry" | "target";
  onClick?: () => void;
}

// Component is used only for coach, inside of Client provider used by 'useClient'
export function ClientNutritionTargetEmpty(
  props: ClientNutritionTargetEmptyProps,
) {
  const { type, onClick } = props;
  const s = useStyles();

  const client = useClient();

  const message =
    type === "entry" ? "Your client nutrition entries will appear here" : "Client doesn’t have nutrition targets yet";

  return (
    <Box className={s.emptyContainer}>
      <NutritionTargetsEmptyIcon />
      <Typography variant="body1" className={s.emptyText}>
        {message}
      </Typography>
      {Boolean(client) && type === "target" && (
        <Button
          className={s.button}
          children="Set target"
          variant="outlined"
          onClick={onClick}
        />
      )}
    </Box>
  );
}
